var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 10.4995L9.70316 14.6348C9.81248 14.6911 9.86714 14.7192 9.92447 14.7303C9.97525 14.7401 10.0274 14.7401 10.0781 14.7303C10.1355 14.7192 10.1901 14.6911 10.2994 14.6348L18.3346 10.4995M1.66797 14.7882L9.70316 18.9235C9.81248 18.9798 9.86714 19.0079 9.92447 19.019C9.97525 19.0288 10.0274 19.0288 10.0781 19.019C10.1355 19.0079 10.1901 18.9798 10.2994 18.9235L18.3346 14.7882M1.66797 6.21077L9.70316 2.07547C9.81248 2.01921 9.86714 1.99108 9.92447 1.98001C9.97525 1.9702 10.0274 1.9702 10.0781 1.98001C10.1355 1.99108 10.1901 2.01921 10.2994 2.07547L18.3346 6.21077L10.2994 10.3461C10.1901 10.4023 10.1355 10.4305 10.0781 10.4415C10.0274 10.4513 9.97525 10.4513 9.92447 10.4415C9.86714 10.4305 9.81248 10.4023 9.70316 10.3461L1.66797 6.21077Z",
    stroke: "#38CB89",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.3bbbd585a3c123589cb9055ff6e6cef7.svg";
export { ForwardRef as ReactComponent };